import React from 'react'
import { Outlet, NavLink  } from 'react-router-dom'
const Cms = () => {
    return (
        <>
            <div className="row mb-5">
                <div className="col-md-12">
                    <div className="card card-rounded border">
                        <div className="card-header">
                            <h3 className="card-title align-items-start flex-column">
                                <span className="card-label fw-bold text-dark d-flex">
                                    <NavLink to="cms/manage-pricing-module"
                                        className="nav-item mt-2 cursor-pointer text-hover-primary"
                                    >
                                        {({ isActive }) => (
                                            <div className={`nav-link ms-0 me-10 py-5 ${isActive ? "tab-active" : "text-gray-600"}`}>
                                                Manage Pricing Module
                                            </div>
                                        )}
                                    </NavLink>
                                    <NavLink to="cms/manage-video"
                                        className="nav-item mt-2 cursor-pointer text-hover-primary"
                                    >
                                        {({ isActive }) => (
                                            <div className={`nav-link ms-0 py-5 ${isActive ? "tab-active" : "text-gray-600"}`}>
                                                Manage Video
                                            </div>
                                        )}
                                    </NavLink>
                                </span>
                            </h3>
                        </div>
                    </div>
                </div>
            </div>
            <Outlet/>
        </>
    )
}

export default Cms